export const _vesselContainerHeight = {
  Geared: {
    Small: '72%',
    Medium: '87%',
    Large: '100%'
  },
  Gearless: {
    Small: '72%',
    Medium: '87%',
    Large: '100%'
  }
}

export const _BubbleInfoRightPosition = {
  Geared: {
    Small: '-5.2rem',
    Medium: '-5rem',
    Large: '-4.4rem'
  },
  Gearless: {
    Small: '-5.2rem',
    Medium: '-5rem',
    Large: '-4.4rem'
  }
}

export const _getVesselSize = (data) => {
  if (data) {
    let array = data.split('|')
    let sizes = array[1].replace(/[/_ ]/g, '') || 'Large'
    return sizes
  }
  return 'Small'
}

export const _getVesselImage = (name) => {
  if (name) {
    let array = name.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    let sizes = array[1].replace(/[/_ ]/g, '')

    return `V${names}${sizes}`
  }
}

export const _getAdditionalImage = (name, type) => {
  if (name) {
    let array = name.split('|')
    let sizes = array[1].replace(/[/_ ]/g, '')
    return `Add${type}${sizes}`
  }
}

export const _getVesselContainerHeight = (data) => {
  const defaultPosition = 0

  if (data) {
    let array = data.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    let sizes = array[1].replace(/[/_ ]/g, '') || 'Large'
    if (names === 'Geared' || names === 'Gearless') {
      const height = _vesselContainerHeight[names][sizes]
      return height
    }
    return defaultPosition
  }
  return defaultPosition
}

export const _getBubbleRightPositions = (data) => {
  const defaultPosition = { right: 0 }

  if (data) {
    let array = data.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    let sizes = array[1].replace(/[/_ ]/g, '') || 'Large'

    if (names === 'Geared' || names === 'Gearless') {
      const right = _BubbleInfoRightPosition[names][sizes]
      return right
    }
    return defaultPosition
  }
  return defaultPosition
}

export const isGearedOrGearless = (data) => {
  if (data) {
    let array = data.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    if (names === 'Geared' || names === 'Gearless') {
      return true
    }
    return false
  }
}
